// Mock data for frontend-only implementation
// This will be replaced with actual backend API calls later

export const MOCK_TESTIMONIALS = [
  {
    id: 1,
    name: "Sarah",
    role: "Marketing Director",
    content: "Raffi transformed our online presence completely. Our organic traffic increased by 340% in just 6 months, and we're now ranking #1 for our main keywords. His AI-powered approach saved us countless hours."
  },
  {
    id: 2,
    name: "Michael",
    role: "Founder & CEO",
    content: "Working with Raffi was a game-changer for our local business. His local SEO strategies brought us to the top of Google Maps, and our foot traffic doubled. The ROI has been phenomenal."
  },
  {
    id: 3,
    name: "Jessica",
    role: "E-commerce Manager",
    content: "Raffi's video marketing and SEO strategy helped us reach millions. Our YouTube channel went from 5K to 150K subscribers in one year, and website conversions increased by 280%. Absolutely outstanding results."
  }
];